/**
 * Extend Marb namespace
 */

try {
	Marb.extend({
		Company: (function(){
			var updateAcceptCreditCard = function(data, onSuccess, onFail) {
				$.ajax('/secure/company/credit-card',{
					method : "POST",
					dataType: 'json',
					data: {"accept": data},
					success: function(data){
						if(data.success){
							Marb.Page.Toast.success({
								text: $.i18n.prop('p.toast.modification.success')
							});
							if(onSuccess != undefined){
								onSuccess();
							}
							return true;
						}else{
							Marb.Page.Toast.error({
								text: $.i18n.prop('p.toast.modification.error')
							});
							if(onFail != undefined){
								onFail();
							}
							return false;
						}
					},
					error: function(){
						Marb.Page.Toast.error({
							text: $.i18n.prop('p.toast.modification.error')
						});
						if(onFail != undefined){
							onFail();
						}
						return false;
					}
				});
			};
			
			var acceptCreditCard = function(onSuccess, onFail) {
				return Marb.Company.updateAcceptCreditCard(true, onSuccess, onFail);
			};
			
			
			var removeAcceptCreditCard = function(onSuccess, onFail) {
				return Marb.Company.updateAcceptCreditCard(false, onSuccess, onFail);
			};
			
			var isCreditCardAccepter = function(quoteId, acceptsCC) {
				var quoteId = quoteId;			
				acceptsCC = acceptsCC || function(){};
				$.get('/company/quote/'+quoteId+'/accepts-creditcard').done(function(response){
					var hasResponse = false;					
					if(response.success){
						acceptsCC(response.data.acceptsCreditCard);
					}
				});
			};
			
			
			var loadProfile = function(data){
				var container = data.container;
				if( $(container).data('loadprofile') ){
					return;
				}
				$(container).data('loadprofile', 'true');
				$(container).load('/company/' + data.companyId + '/shortprofile/', function(){
					Marb.Page.scrollables(container);
				});
			};
			
			var loadChecks = function(data){
				var container = data.container;
				if( $(container).data('loadchecks') ){
					return;
				}
				$(container).data('loadchecks', 'true');
				$(container).load('/company/' + data.companyId + '/checks/');
			};
			
			var loadPortfolio = function(data){
				var container = data.container;
				if( $(container).data('loadportfolio') ){
					return;
				}
				$(container).data('loadportfolio', 'true');
				$(container).load('/company/' + data.companyId + '/portfolio/');
			};
			
			var loadComments = function(data) {
				var companyId = data.companyId;
				var content = data.container || (data.selector ? $(data.selector) : null);
				var page = data.pageNum || 1;
				if( $(content).data('maxpage') && page <= $(content).data('maxpage')){
					return;
				}
				var parent = data.parent || content;
				$.get('/company/' + companyId + '/reviews/', {p: page}, function(response){
					var hasResponse = false;
					var container = content;
					if(response.success){
						if( page == 1 ){
							container = $('<div class="comment-container"></div>');
							content.append(container);
						}
						$(content).data('maxpage', page);
						var votes = response.data.votes;
						hasResponse = votes.length > 0;
						hasMore = hasResponse && votes.length == response.data.maxResults;
						for(var i=0; i < votes.length; i++){
							var vote = votes[i];
							var commentBody = '"' + vote.commentBody + '"';
							if( Marb.Commons.Utils.isBlank(vote.commentBody) ){
								commentBody = $.i18n.prop('p.generic.comment.nocomment');
							}
							var commentElem = 
								$('<div class="vote-comment"></div>');
							var bodyElem = $('<div class="comment-body text-m">' +  
								commentBody + '</div>');
							var separator = $('<div class="comment-separator"> ' +
											  '     <span class="down-separator">&nbsp;</span>  ' +
											  '</div>');
							var footerElem = $('<div class="comment-footer"></div>');
							var authorData = vote.authorName + ', ' + vote.locationName + ', ' + Marb.Commons.Utils.elapsedTimeText(vote.createdOn);
							footerElem.append(
								'<div class="comment-author">' + authorData + '</div>'
							);
							var rating = $('<div class="comment-rating-container"> \
												<div class="rating-type rating-'+ vote.outcomeType +'"></div> \
											</div>');
							rating.append(Marb.Page.drawStars({value: vote.overallRating}));
							footerElem.append(rating);
							footerElem.append('<div class="clear"></div>');
							commentElem.append(bodyElem);
							commentElem.append(separator);
							commentElem.append(footerElem);
							
							container.append(commentElem);
						}
						container.find('.comment-load-more').remove();
						if(hasMore){
							var loadMoreElem = $('<div class="text-m font-c1 comment-load-more">' + $.i18n.prop('p.company.profile.menu.comments.loadMore') + '</div>');
							container.append(loadMoreElem);
							loadMoreElem.on('click', function(){
								Marb.Company.loadComments({
									companyId: companyId,
									container: container,
									pageNum: (page + 1),
									parent: parent
								});
							});
						}
						if( page == 1){
							Marb.Page.scrollables(content);
						}
						Marb.Page.scrollable(parent, 'update');
					}
					if( ! hasResponse ){
						var text = page == 1 ? $.i18n.prop('p.generic.comment.nocomments') : 
							$.i18n.prop('p.generic.comment.nomore');
						var element = $('<div class="text-m comment-nomore">' + text + '</div>');
						content.prepend(element);

						Marb.Page.scrollable(parent, 'update');
					}
				});
			};
			
			return {
				loadComments: loadComments,
				loadChecks: loadChecks,
				loadPortfolio: loadPortfolio,
				loadProfile: loadProfile,
				updateAcceptCreditCard : updateAcceptCreditCard,
				acceptCreditCard : acceptCreditCard,
				removeAcceptCreditCard : removeAcceptCreditCard,
				isCreditCardAccepter : isCreditCardAccepter,
			};
		})()
	});
}
catch (e) {
	debug.error("Marb namespace not present", e);
}
